<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CDialog from '@/shared/ui/CDialog.vue'
import CCookiePreferencesForm from './CCookiePreferencesForm.vue'

/**
 * Modal shell around {@link CCookiePreferencesForm}. Used from the
 * cookie banner's "Customize" action so anonymous visitors can set
 * granular preferences without having to log in and find the profile
 * tab — which would contradict the GDPR requirement that withdrawing
 * consent be as frictionless as granting it.
 */

const model = defineModel<boolean>({ required: true })
const { t } = useI18n()

function onSaved() {
  // The form already persisted + toasted; closing the dialog is the
  // only remaining UI concern.
  model.value = false
}

function onWithdrawn() {
  model.value = false
}
</script>

<template>
  <CDialog v-model="model" :title="t('cookie_preferences_title')">
    <CCookiePreferencesForm @saved="onSaved" @withdrawn="onWithdrawn" />
  </CDialog>
</template>
